/** Text with `code` spans written in backticks. */
export default function Prose({ text, className = '' }: { text: string; className?: string }) {
  const parts = text.split(/(`[^`]+`)/g)
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.startsWith('`') && p.endsWith('`') && p.length > 1
          ? <code key={i} className="px-1 py-px rounded bg-slate-100 text-[0.92em] font-mono text-qcloud-text">{p.slice(1, -1)}</code>
          : <span key={i}>{p}</span>,
      )}
    </span>
  )
}
